<template>
    <div class="container">
         <div class="dashboard__dates">
            <div class="box box--dark-green" v-bind:class="{pending: pending}">
                <div class="row">
                    <div class="col-lg-4">
                        <h2 class="h h--2 dashboard__dates-h2">Wypożyczalnia narzędzi</h2>
                       
                    </div>
                    <div class="col-lg-8">
                        <h3 class="dashboard__dates-subheader" style="line-height: 2">Chcesz wypożyczyć narzędzia Geberit? <br>Skontaktuj się z firmą <a href="https://www.ramirent.pl" class="box__link"><b>RAMIRENT</b></a> albo <router-link :to="{name: 'Contact'}" class="box__link"><b>Doradcą Technicznym Geberit</b></router-link></h3>
                    </div>
                </div>
            </div>
        </div>
        
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'ToolsComponent',
  data () {
    return {
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  mounted: function() {
    if( !this.user || this.user.id != 1   ) {
        this.$gtag.pageview({
            page_path: '/wypozyczalnia-narzedzi',
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/tools/ToolsComponent.vue